import "../../css/TiptapEditor.css";
import { CSSProperties, useEffect } from "react";
import { EditorContent } from "@tiptap/react";
import { JSONContent } from "@markit/common.types";
import { useRichTextEditor } from "../../hooks/useRichTextEditor";
import { ThemeStyle } from "../../hooks/useTheme";

type ReadOnlyRichTextEditorProps = {
  body: JSONContent;
  theme: ThemeStyle;
  addImageExtension?: boolean;
  className?: string;
  fontSize?: number;
  editorStyle?: CSSProperties;
};

// Component to render a readonly rich text editor
const ReadOnlyRichTextEditor = (props: ReadOnlyRichTextEditorProps) => {
  const { body, theme, addImageExtension, className, fontSize, editorStyle } =
    props;

  const { editor: readOnlyEditor } = useRichTextEditor({
    body: body,
    styles: "",
    isReadOnly: true,
    addImageExtension,
    theme,
    fontSize,
  });

  // Set the content after loading the post data
  useEffect(() => {
    if (!readOnlyEditor) {
      return;
    }
    readOnlyEditor.commands.setContent(body);
  }, [body, readOnlyEditor]);

  return (
    <EditorContent
      editor={readOnlyEditor}
      className={className}
      style={{
        wordWrap: "break-word",
        overflowWrap: "break-word",
        wordBreak: "break-word",
        ...editorStyle,
      }}
    />
  );
};

export default ReadOnlyRichTextEditor;
